import STRINGS from '@/constants/strings'

import Picture from '../picture'
import ThreeDSwiper from '../ThreeDSwiper'

const microEntrepreneurAssetDir = '/assets/images/solutions/micro-entrepreneur'

const TrainingAndBusinessDevelopmentData = [
  {
    label: STRINGS.MICRO_ENTREPRENEUR.SECTION_ONE_LABEL,
    desp: STRINGS.MICRO_ENTREPRENEUR.SECTION_ONE_DESP,
    imageUrl: `${microEntrepreneurAssetDir}/organize`,
  },
  {
    label: STRINGS.MICRO_ENTREPRENEUR.SECTION_TWO_LABEL,
    desp: STRINGS.MICRO_ENTREPRENEUR.SECTION_TWO_DESP,
    imageUrl: `${microEntrepreneurAssetDir}/implement`,
  },
  {
    label: STRINGS.MICRO_ENTREPRENEUR.SECTION_THREE_LABEL,
    desp: STRINGS.MICRO_ENTREPRENEUR.SECTION_THREE_DESP,
    imageUrl: `${microEntrepreneurAssetDir}/touch-screen`,
  },
  {
    label: STRINGS.MICRO_ENTREPRENEUR.SECTION_FOUR_LABEL,
    desp: STRINGS.MICRO_ENTREPRENEUR.SECTION_FOUR_DESP,
    imageUrl: `${microEntrepreneurAssetDir}/cloud-computing`,
  },
  {
    label: STRINGS.MICRO_ENTREPRENEUR.SECTION_FIVE_LABEL,
    desp: STRINGS.MICRO_ENTREPRENEUR.SECTION_FIVE_DESP,
    imageUrl: `${microEntrepreneurAssetDir}/thought`,
  },
]

const sliderImageList = [
  {
    id: 1,
    webImage: `${microEntrepreneurAssetDir}/slide-1`,
    altText:
      'Immediate order all types of best commodities from the application',
  },
  {
    id: 2,
    webImage: `${microEntrepreneurAssetDir}/slide-2`,
    altText: 'All business transactions history available on Dehaat',
  },
  {
    id: 3,
    webImage: `${microEntrepreneurAssetDir}/slide-3`,
    altText: 'Pay online easily and get cashback',
  },
  {
    id: 4,
    webImage: `${microEntrepreneurAssetDir}/slide-4`,
    altText: 'Credit facilty will make your business grow',
  },
  {
    id: 5,
    webImage: `${microEntrepreneurAssetDir}/slide-5`,
    altText: 'Enhance rating of shop and get more benefit',
  },
  {
    id: 6,
    webImage: `${microEntrepreneurAssetDir}/slide-6`,
    altText: 'Help regarding any transaction on app',
  },
]

export default function MicroEntrepreneur() {
  return (
    <>
      <section className="max-w-7xl m-auto">
        <div className="pb-12 flex flex-col md:flex-row flex-nowrap">
          <div className="relative px-4">
            <h1 className="font-natosans-regular text-black text-3xl md:text-5xl mt-5 mb-2">
              {STRINGS.MICRO_ENTREPRENEUR.HEADING}
            </h1>
            <h5 className="text-[#6bb51e] text-xl md:text-3xl font-natosans font-normal">
              {STRINGS.MICRO_ENTREPRENEUR.SUB_HEADING}
            </h5>
            <div className="text-[#646464] font-natosans-light pt-6">
              <p>
                {STRINGS.MICRO_ENTREPRENEUR.DESCRIPTION_TEXT}
                <br />
                <br />
                {STRINGS.MICRO_ENTREPRENEUR.DESCRIPTION_TEXT_2}
              </p>
            </div>
            <div className="mt-4">
              <div className="flex flex-row">
                <Picture
                  image={`${microEntrepreneurAssetDir}/business-app`}
                  imageAlt={STRINGS.COMMON.DEHAAT_BUSINESS_APP}
                  imageStyle="w-10"
                  pictureStyle="flex items-center"
                />
                <div className="pl-4">
                  <a
                    href="https://play.google.com/store/apps/details?id=com.intspvt.app.dehaat2"
                    rel="nofollow noreferrer"
                    target="_blank"
                    className="font-natosans-regular text-black text-base"
                  >
                    {STRINGS.COMMON.DOWNLOAD}
                    <br />
                    {STRINGS.COMMON.DEHAAT_BUSINESS_APP}
                  </a>
                </div>
              </div>
            </div>
          </div>
          <Picture
            image={`${microEntrepreneurAssetDir}/entrepreneur-header-img`}
            imageAlt="Dehaat Testimonial"
            imageStyle="w-1/2 m-auto pt-12 md:min-w-[200px]"
            pictureStyle="px-4 md:min-w-[33%]"
          />
        </div>
      </section>
      <section className="bg-[#081621] py-12">
        <div className="px-4 max-w-7xl m-auto">
          <div className="col-md-9 pt-4">
            <h6 className="text-white font-natosans-regular text-xl md:text-3xl my-3">
              {STRINGS.MICRO_ENTREPRENEUR.TRAINING_BUSSINESS_DEVELOPMENT}
            </h6>
          </div>
          <div className="pt-12 flex flex-wrap">
            {TrainingAndBusinessDevelopmentData.map(
              ({ imageUrl, label, desp }) => (
                <div className="w-full md:w-1/3" key={label}>
                  <div className="flex-row flex mb-10 mr-0 md:mb-3 md:mr-10">
                    <Picture
                      image={imageUrl}
                      imageAlt={label}
                      imageStyle="w-16"
                      pictureStyle="w-16"
                    />
                    <div className="w-fit ml-5 font-natosans-regular text-[#e0e0e0]">
                      <h6 className="text-xl">{label}</h6>
                      <h6 className="text-sm my-2">{desp}</h6>
                    </div>
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </section>
      <section className="py-4 wow slideInUp overflow-hidden max-w-6xl m-auto">
        <ThreeDSwiper sliderImageList={sliderImageList} />
      </section>
    </>
  )
}
